import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.8_@netlify+blobs@9.1.2_@parcel+watcher@2.5.6_@types+node@25.2.3_@upstash+redi_01ef9c286f543dd8bd2f965aa464f458/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}